import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isToday from 'dayjs/plugin/isToday'
import isoWeek from 'dayjs/plugin/isoWeek'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

import 'dayjs/locale/ru'
import 'dayjs/locale/uz'
import 'dayjs/locale/uz-latn'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isToday)
dayjs.extend(isoWeek)
dayjs.extend(weekOfYear)
dayjs.extend(quarterOfYear)
dayjs.extend(duration)

export function getLocale(lang: string): string {
  switch (lang) {
    case 'uzLAT':
      dayjs.locale('uz-latn')
      return 'uz-latn'
    case 'ruRUS':
      dayjs.locale('ru')
      return 'ru'
    default:
      dayjs.locale('uz')
      return 'uz'
  }
}

export function getAntdLocale(lang: string): Promise<{ default: any }> {
  switch (lang) {
    case 'uzCYR':
    case 'uzLAT':
      return import('antd/locale/uz_UZ')
    case 'ruRUS':
      return import('antd/locale/ru_RU')
    default:
      return import('antd/locale/uz_UZ')
  }
}

export {
  utc,
  dayjs,
  isToday,
  isoWeek,
  duration,
  timezone,
  isBetween,
  weekOfYear,
  isSameOrBefore,
  localizedFormat,
  customParseFormat,
  quarterOfYear,
}
